export default {
	GM: 1,
	Chrysler: 2,
	Toyota: 3,
	Daewoo: 4,
	Abarth: 5,
	Acura: 6,
	Alfa_Romeo: 7,
	Aston_Martin: 8,
	Audi: 9,
	Bentley: 10,
	BMW: 11,
	Bugatti: 12,
	Buick: 13,
	Cadillac: 14,
	Chevrolet: 15,
	Citroen: 16,
	Daihatsu: 17,
	Datsun: 18,
	De_Lorean: 19,
	Dodge: 20,
	Eagle: 21,
	Ferrari: 22,
	Fiat: 23,
	Ford: 24,
	GEO: 25,
	GMC: 26,
	Honda: 27,
	Hyundai: 28,
	Infiniti: 29,
	Isuzu: 30,
	Jaguar: 31,
	Kia: 32,
	Lamborghini: 33,
	Lexus: 34,
	Lincoln: 35,
	Lotus: 36,
	MG: 37,
	Mitsubishi: 38,
	Peugeot: 39,
	Plymouth: 40,
	Pontiac: 41,
	Porsche: 42,
	Renault: 43,
	Rolls_Royce: 44,
	Saab: 45,
	Saturn: 46,
	Sterling: 47,
	Subaru: 48,
	Suzuki: 49,
	Volkswagen: 50,
	Volvo: 51,
	Hummer: 52,
	Jeep: 53,
	Land_Rover: 54,
	Mazda: 55,
	Mercedes_Benz: 56,
	Mercury: 57,
	Nissan: 58,
	Mini_Cooper: 59,
	Oldsmobile: 60,
	Scion: 61,
	Smart: 62,
	Ram: 63,
	Genesis: 64,
	Kawasaki: 65
};
